import gsap from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'

import Site from 'stores/Site'

import Page from 'classes/Page'

export default class Industry extends Page {
    constructor() {
        super()
    }

    init() {
        super.init()

        this.initScroller()
    }

    initScroller() {
        if (Site.isMobile) return

        gsap.registerPlugin(ScrollTrigger)

        const section = Site.page.querySelector('.s-info-scroller')
        const wrapper = section.querySelector('.scroller')
        const items = section.querySelectorAll('.scroller-item')
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: wrapper,
                start: 'center center',
                end: '+=200%',
                pin: section,
                scrub: true
            }
        })

        items.forEach((el, i) => {
            if (i > 0) {
                tl.fromTo(el, {
                    top: `${2.4 * i}rem`,
                    yPercent: 150
                }, {
                    yPercent: 0
                }, i - 1)
            }
        })
    }

    onResize() {
        super.onResize()
    }

    onScroll() {
        super.onScroll()
    }
}